import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=45e7f6be&scoped=true"
import script from "./PaymentPix.vue?vue&type=script&lang=js"
export * from "./PaymentPix.vue?vue&type=script&lang=js"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=45e7f6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e7f6be",
  null
  
)

export default component.exports